import React from "react"
import styled from "styled-components"
import gradient1 from "../images/gradient1.png"

const PremiumGroup = styled.div`
  height: 800px;
  margin: 0;
  display: grid;
  grid-gap: 0;
  position: relative;
  justify-items: center;

  @media (max-width: 1200px) {
    height: 900px;
  }

  @media (max-width: 900px) {
    height: 1800px;
  }

  @media (max-width: 500px) {
    height: 1450px;
  }
`

const CardDivider = styled.div`
  margin: 10px 50px;
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 50px;
  justify-items: center;

  @media (max-width: 900px) {
    grid-template-columns: repeat(1, 1fr);
    margin: 10px 20px;
    grid-gap: 0px;
  }
`

const FreeCard = styled.div`
  background-image: url("https://images.unsplash.com/photo-1485970671356-ff9156bd4a98?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=1f5e4119375aee6f58a835ee9b7b187f&auto=format&fit=crop&w=634&q=");
  width: 500px;
  height: 800px;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
  transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
  color: black;

  @media (max-width: 1200px) {
    width: 400px;
  }

  @media (max-width: 500px) {
    width: 300px;
    height: 600px;
    border-radius: 15px;
  }
`

const PremiumCard = styled.div`
  background: url("https://images.unsplash.com/photo-1500327324249-e434c1bfdfab?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=986190cd508e1d9034215871201c1846&auto=format&fit=crop&w=634&q=100");
  width: 500px;
  height: 800px;
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
  transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
  color: black;
  @media (max-width: 1200px) {
    width: 400px;
  }

  @media (max-width: 500px) {
    width: 300px;
    height: 700px;
    border-radius: 15px;
  }
`

const CardTitle = styled.h1`
  color: white;
  font-size: 60px;
  font-weight: 600px;
  margin: 20px 10px;
  text-align: center;
  @media (max-width: 500px) {
    font-size: 50px;
    font-weight: 600px;
    margin: 10px 10px;
  }
`

const CardSubtitle = styled.h3`
  color: white;
  font-size: 25px;
  margin: 20px 30px 50px 30px;
  text-align: center;
  @media (max-width: 1200px) {
    font-weight: 700;
    font-size: 20px;
  }

  @media (max-width: 500px) {
    margin: 20px 5px 50px 5px;
  }
`

const CardParagraph = styled.p`
  color: white;
  font-size: 20px;
  font-weight: 600;
  margin: 20px 50px;
  text-align: left;
  @media (max-width: 1200px) {
    font-size: 20px;
  }

  @media (max-width: 500px) {
    margin: 20px 10px;
    text-align: center;
  }
`

const FooterGroup = styled.div`
  width: auto;
  color: #486791;
  max-width: 500px;
  margin: 0 auto;
  padding: 100px 0 50px 0;
  text-align: center;
  font-size: 20px;
  @media (max-width: 1200px) {
    padding: 20px;
  }
`

const FooterText = styled.p`
  font-weight: 500;
  font-size: 24px;
  color: #486791;
  max-width: 600px;
  margin: 0 10px;
  text-align: center;
  @media (max-width: 500px) {
    font-size: 17px;
  }
`

const PricingComponent = props => (
  <div>
    <PremiumGroup>
      <CardDivider>
        <FreeCard>
          <CardTitle>Free</CardTitle>
          <CardSubtitle>Stay Updated with the Top News!</CardSubtitle>
          <CardParagraph>➤ Get notified of the latest stories</CardParagraph>
          <CardParagraph>
            ➤ Post 3 stories per month on the Community
          </CardParagraph>
          <CardParagraph>
            ➤ Express your opinion with emojis and comments
          </CardParagraph>
          <CardParagraph>
            ➤ Access your account from any iOS device
          </CardParagraph>
        </FreeCard>
        <PremiumCard>
          <CardTitle>Premium</CardTitle>
          <CardSubtitle>
            Share your Opinion on Breaking News for only $0.99 per month!
          </CardSubtitle>
          <CardParagraph>➤ Get notified of the latest stories</CardParagraph>
          <CardParagraph>
            ➤ Post <b>unlimited</b> stories on the Community
          </CardParagraph>
          <CardParagraph>
            ➤ Express your opinions with emojis and comments
          </CardParagraph>
          <CardParagraph>
            ➤ Access your account from any iOS device
          </CardParagraph>
          <CardParagraph>➤ Get a verified account</CardParagraph>
          <CardParagraph>➤ Unlock all themes</CardParagraph>
          <CardParagraph>
            ➤ Get Felicity to summarize long news articles into short sentences
          </CardParagraph>
        </PremiumCard>
      </CardDivider>
    </PremiumGroup>
    <FooterGroup>
      <FooterText>
        Search the app for "Let It Snow". You'll be pleasantly surprised!
      </FooterText>
    </FooterGroup>
  </div>
)

export default PricingComponent
